var map = {
	"./maigeki-showdown-2026.json": [
		9014,
		160
	],
	"./maigeki-showdown.json": [
		4708,
		484
	],
	"./ongeki_bright_memory_act_2.json": [
		2341,
		591
	],
	"./ongeki_bright_memory_act_3.json": [
		3256,
		942
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2616;
module.exports = webpackAsyncContext;